__turbopack_context__.v({
  "imageSlot": "PNgK0G_imageSlot",
  "left": "PNgK0G_left",
  "right": "PNgK0G_right",
  "wrapper": "PNgK0G_wrapper",
});
